import { Container } from "react-bootstrap";
import DotTexts from "./components/helper/DotTexts";
import UnderLine from "./components/helper/UnderLine";
import FormVerify from "./components/form/FormVerify";

const Home = () => {
  return (
    <>
      <div className="main-area">
        <Container>
          <DotTexts
            text="GEMS CERTIFICATION"
            color="#A9A3A3"
            justify="flex-start"
          />

          <div className="elevate-text">
            <p>
              Verify a <span>GEMS Certificate </span>
            </p>
            <UnderLine width="50px" height="2px" />
          </div>
        </Container>
        <Container className="from-container mt-5">
          <FormVerify />
        </Container>
      </div>
    </>
  );
};

export default Home;
